import axios from '../utils/axios';
import $ from "jquery";

const updateCartIconQuantity = function updateCartIconQuantity(responseData) {
    let countCartElements = 0;
    let cartCounter = $('.cart-counter');

    (responseData ? Promise.resolve(responseData) : axios.get(window.config.urls.cartItemCounter))
        .then(({data: data}) => {
            if (data.mergeCartsDialog) {
                $('#transferCartModal').modal('show');
            }

            if (data.invalidOfferDialog) {
                let modal = $('#invalid-offer-modal');
                let form = modal.find('>form:first');

                modal.find('#invalid-offer-cancel').data('url', data.invalidOfferDialog.cancelUrl);
                modal.find('#invalid-offer-change').data('url', data.invalidOfferDialog.changeUrl);

                $('.invalid-offer-action').on('click', event => {
                   event.preventDefault();

                   form.attr('action', $(event.currentTarget).data('url'));
                   form.trigger('submit');
                });

                modal.modal('show');
            }

            if (data.count) {
                countCartElements = data.count;
            } else if (data.items) {
                countCartElements = Object.keys(data.items).length;
            } else {
                return;
            }

            if (cartCounter) {
                if(countCartElements > 0) {
                    $('.cart-counter').removeClass('visually-hidden');
                    $('.cart-counter').text(countCartElements);
                } else {
                    $('.cart-counter').addClass('visually-hidden');
                }
            }
        })
}

export default updateCartIconQuantity;
